module.exports = __webpack_public_path__ + "static/media/loading11.f9e0c108.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading11.png
// module id = 196
// module chunks = 0